'use client';

import React, { useState } from 'react';

interface Integration {
  name: string;
  category: string;
  logo: string;
  description: string;
}

const IntegrationsSection = () => {
  const integrations: Integration[] = [
  {
    name: 'Salesforce',
    category: 'CRM',
    logo: '☁️',
    description: 'Sync leads and customer data automatically'
  },
  {
    name: 'HubSpot',
    category: 'CRM',
    logo: '🔶',
    description: 'Integrate with marketing automation'
  },
  {
    name: 'Twilio',
    category: 'Communication',
    logo: '📱',
    description: 'Connect with phone systems seamlessly'
  },
  {
    name: 'Slack',
    category: 'Communication',
    logo: '💬',
    description: 'Get real-time notifications'
  },
  {
    name: 'Zapier',
    category: 'Automation',
    logo: '⚡',
    description: 'Connect to 5,000+ apps'
  },
  {
    name: 'Google Calendar',
    category: 'Scheduling',
    logo: '📆',
    description: 'Manage appointments effortlessly'
  },
  {
    name: 'Microsoft Teams',
    category: 'Communication',
    logo: '👥',
    description: 'Collaborate with your team'
  },
  {
    name: 'Zendesk',
    category: 'Support',
    logo: '🎫',
    description: 'Handle support tickets efficiently'
  }];


  const categories = ['All', 'CRM', 'Communication', 'Automation', 'Scheduling', 'Support'];
  const [selectedCategory, setSelectedCategory] = React.useState('All');

  const filteredIntegrations =
  selectedCategory === 'All' ?
  integrations :
  integrations.filter((integration) => integration.category === selectedCategory);

  return;













































































};

export default IntegrationsSection;